// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host-context(.aulani) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
}
:host-context(.aulani) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.aulani) *:before, :host-context(.aulani) *:after {
  box-sizing: border-box;
}
:host-context(.aulani) *:focus {
  outline: 1px dotted #000;
}
:host-context(.aulani) html,
:host-context(.aulani) body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.aulani) body {
  width: 100%;
}
:host-context(.aulani) img {
  width: 100%;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5 {
  margin: 0;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) span,
:host-context(.aulani) a,
:host-context(.aulani) li,
:host-context(.aulani) p,
:host-context(.aulani) input,
:host-context(.aulani) textarea {
  font-family: inherit;
}
:host-context(.aulani) .clearfix {
  zoom: 1;
}
:host-context(.aulani) .clearfix:after {
  clear: both;
}
:host-context(.aulani) .clearfix:after, :host-context(.aulani) .clearfix:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.aulani) .float-left {
  float: left;
}
:host-context(.aulani) .float-right {
  float: right;
}
:host-context(.aulani) html,
:host-context(.aulani) body,
:host-context(.aulani) div,
:host-context(.aulani) span,
:host-context(.aulani) object,
:host-context(.aulani) iframe,
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) p,
:host-context(.aulani) blockquote,
:host-context(.aulani) pre,
:host-context(.aulani) abbr,
:host-context(.aulani) address,
:host-context(.aulani) address,
:host-context(.aulani) cite,
:host-context(.aulani) code,
:host-context(.aulani) del,
:host-context(.aulani) dfn,
:host-context(.aulani) em,
:host-context(.aulani) img,
:host-context(.aulani) ins,
:host-context(.aulani) kbd,
:host-context(.aulani) q,
:host-context(.aulani) samp,
:host-context(.aulani) small,
:host-context(.aulani) strong,
:host-context(.aulani) sub,
:host-context(.aulani) sup,
:host-context(.aulani) var,
:host-context(.aulani) b,
:host-context(.aulani) i,
:host-context(.aulani) dl,
:host-context(.aulani) dt,
:host-context(.aulani) dd,
:host-context(.aulani) ol,
:host-context(.aulani) ul,
:host-context(.aulani) li,
:host-context(.aulani) fieldset,
:host-context(.aulani) form,
:host-context(.aulani) label,
:host-context(.aulani) legend,
:host-context(.aulani) table,
:host-context(.aulani) caption,
:host-context(.aulani) tbody,
:host-context(.aulani) tfoot,
:host-context(.aulani) thead,
:host-context(.aulani) tr,
:host-context(.aulani) th,
:host-context(.aulani) td,
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) canvas,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section,
:host-context(.aulani) summary,
:host-context(.aulani) time,
:host-context(.aulani) mark,
:host-context(.aulani) audio,
:host-context(.aulani) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) img,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section {
  display: block;
}
:host-context(.aulani) ol,
:host-context(.aulani) ul {
  list-style: none;
}
:host-context(.aulani) blockquote,
:host-context(.aulani) q {
  quotes: none;
}
:host-context(.aulani) blockquote :before,
:host-context(.aulani) blockquote :after,
:host-context(.aulani) q :before,
:host-context(.aulani) q :after {
  content: none;
}
:host-context(.aulani) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.aulani) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.aulani) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.aulani) input,
:host-context(.aulani) select {
  vertical-align: middle;
}
:host-context(.aulani) address {
  font-style: normal;
}
:host-context(.aulani) input::-ms-clear {
  display: none;
}
:host-context(.aulani) button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.aulani) .loader.medium-loader {
  text-align: center;
  padding-top: calc(50vh - 92px - 30px);
  padding-bottom: 30px;
}
:host-context(.aulani) .loader.medium-loader wdpr-rt-aulani-loading {
  display: inline-block;
  vertical-align: middle;
}
:host-context(.aulani) .loader.medium-loader span {
  display: inline-block;
  vertical-align: middle;
  font-family: "InspireTWDCMedium";
  font-size: 14px;
  color: #382613;
}
:host-context(.aulani) .loader.small-loader {
  text-align: center;
}
:host-context(.aulani) .loader.small-loader wdpr-rt-aulani-loading {
  display: inline-block;
  vertical-align: middle;
}
:host-context(.aulani) .loader.small-loader span {
  display: inline-block;
  vertical-align: middle;
  font-family: "InspireTWDCMedium";
  font-size: 14px;
  color: #382613;
}
@media (min-width: 1024px) {
  :host-context(.aulani) .loader.medium-loader {
    padding-top: 100px;
  }
}

:host-context(.wdw) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
}
:host-context(.wdw) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.wdw) *:before, :host-context(.wdw) *:after {
  box-sizing: border-box;
}
:host-context(.wdw) *:focus {
  outline: 1px dotted #000;
}
:host-context(.wdw) html,
:host-context(.wdw) body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.wdw) body {
  width: 100%;
}
:host-context(.wdw) img {
  width: 100%;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5 {
  margin: 0;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) span,
:host-context(.wdw) a,
:host-context(.wdw) li,
:host-context(.wdw) p,
:host-context(.wdw) input,
:host-context(.wdw) textarea {
  font-family: inherit;
}
:host-context(.wdw) .clearfix {
  zoom: 1;
}
:host-context(.wdw) .clearfix:after {
  clear: both;
}
:host-context(.wdw) .clearfix:after, :host-context(.wdw) .clearfix:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.wdw) .float-left {
  float: left;
}
:host-context(.wdw) .float-right {
  float: right;
}
:host-context(.wdw) html,
:host-context(.wdw) body,
:host-context(.wdw) div,
:host-context(.wdw) span,
:host-context(.wdw) object,
:host-context(.wdw) iframe,
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) p,
:host-context(.wdw) blockquote,
:host-context(.wdw) pre,
:host-context(.wdw) abbr,
:host-context(.wdw) address,
:host-context(.wdw) address,
:host-context(.wdw) cite,
:host-context(.wdw) code,
:host-context(.wdw) del,
:host-context(.wdw) dfn,
:host-context(.wdw) em,
:host-context(.wdw) img,
:host-context(.wdw) ins,
:host-context(.wdw) kbd,
:host-context(.wdw) q,
:host-context(.wdw) samp,
:host-context(.wdw) small,
:host-context(.wdw) strong,
:host-context(.wdw) sub,
:host-context(.wdw) sup,
:host-context(.wdw) var,
:host-context(.wdw) b,
:host-context(.wdw) i,
:host-context(.wdw) dl,
:host-context(.wdw) dt,
:host-context(.wdw) dd,
:host-context(.wdw) ol,
:host-context(.wdw) ul,
:host-context(.wdw) li,
:host-context(.wdw) fieldset,
:host-context(.wdw) form,
:host-context(.wdw) label,
:host-context(.wdw) legend,
:host-context(.wdw) table,
:host-context(.wdw) caption,
:host-context(.wdw) tbody,
:host-context(.wdw) tfoot,
:host-context(.wdw) thead,
:host-context(.wdw) tr,
:host-context(.wdw) th,
:host-context(.wdw) td,
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) canvas,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section,
:host-context(.wdw) summary,
:host-context(.wdw) time,
:host-context(.wdw) mark,
:host-context(.wdw) audio,
:host-context(.wdw) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) img,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section {
  display: block;
}
:host-context(.wdw) ol,
:host-context(.wdw) ul {
  list-style: none;
}
:host-context(.wdw) blockquote,
:host-context(.wdw) q {
  quotes: none;
}
:host-context(.wdw) blockquote :before,
:host-context(.wdw) blockquote :after,
:host-context(.wdw) q :before,
:host-context(.wdw) q :after {
  content: none;
}
:host-context(.wdw) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.wdw) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.wdw) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.wdw) input,
:host-context(.wdw) select {
  vertical-align: middle;
}
:host-context(.wdw) address {
  font-style: normal;
}
:host-context(.wdw) input::-ms-clear {
  display: none;
}
:host-context(.wdw) button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.wdw) .loader.medium-loader {
  text-align: center;
  padding-top: calc(50vh - 48px - 27px - 30px);
  padding-bottom: 30px;
}
:host-context(.wdw) .loader.medium-loader wdpr-loading {
  display: inline-block;
  vertical-align: middle;
}
:host-context(.wdw) .loader.medium-loader span {
  display: inline-block;
  vertical-align: middle;
  font-family: "InspireTWDCMedium";
  font-size: 14px;
  color: #253B56;
}
:host-context(.wdw) .loader.small-loader {
  text-align: center;
}
:host-context(.wdw) .loader.small-loader wdpr-loading {
  display: inline-block;
  vertical-align: middle;
}
:host-context(.wdw) .loader.small-loader span {
  display: inline-block;
  vertical-align: middle;
  font-family: "InspireTWDCMedium";
  font-size: 14px;
  color: #253B56;
}
@media (min-width: 767px) {
  :host-context(.wdw) .loader.medium-loader {
    padding-top: calc(50vh - 102px - 40px - 30px);
    padding-bottom: 30px;
  }
}
@media (min-width: 1024px) {
  :host-context(.wdw) .loader.medium-loader {
    padding-top: 100px;
    padding-bottom: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/loader/loader.component.scss","webpack://./src/assets/style/theme/index.scss","webpack://./src/assets/style/abstracts/variables.scss","webpack://./src/assets/style/abstracts/functions.scss","webpack://./src/assets/style/abstracts/mixins.scss","webpack://./src/assets/style/base/global.scss","webpack://./src/assets/style/base/reset.scss","webpack://./src/app/loader/loader.component.aulani.scss","webpack://./src/assets/style/base/font.scss","webpack://./src/app/loader/loader.component.wdw.scss"],"names":[],"mappings":"AAAA;ECAA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;ANoCA;AK7BA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;AL+BJ;AK7BI;EAEI,sBAAA;AL8BR;AK3BI;EACI,wBAAA;AL6BR;AKzBA;;EAEI,SAAA;EACA,iBAAA;AL2BJ;AKxBA;EACI,WAAA;AL0BJ;AKvBA;EACI,WAAA;ALyBJ;AKtBA;;;;;EAKI,SAAA;ALwBJ;AKrBA;;;;;;;;;;;;EAYI,oBAAA;ALuBJ;AKpBA;EACI,OAAA;ALsBJ;AKpBI;EACI,WAAA;ALsBR;AKnBI;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ALoBR;AKhBA;EACI,WAAA;ALkBJ;AKfA;EACI,YAAA;ALiBJ;AMjGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;ANmGJ;AMhGA;;;;;;;;;;;;EAYI,cAAA;ANkGJ;AM/FA;;EAEI,gBAAA;ANiGJ;AM9FA;;EAEI,YAAA;ANgGJ;AM9FI;;;;EAEI,aAAA;ANkGR;AM9FA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;ANgGJ;AM7FA;EACI,yBAAA;EACA,iBAAA;AN+FJ;AM5FA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AN8FJ;AM3FA;;EAEI,sBAAA;AN6FJ;AM1FA;EACI,kBAAA;AN4FJ;AMxFI;EACI,aAAA;AN0FR;AMtFA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANwFJ;AMnFQ;EACI,gBAAA;EACA,cAAA;ANqFZ;AMjFY;EACI,cAAA;ANmFhB;AOtPA;EACI,kBAAA;EACA,qCAAA;EACA,oBAAA;APwPJ;AOtPI;EACI,qBAAA;EACA,sBAAA;APwPR;AOrPI;EACI,qBAAA;EACA,sBAAA;EACA,gCCdkB;EDelB,eAAA;EACA,cNSoB;AD8O5B;AOnPA;EACI,kBAAA;APqPJ;AOnPI;EACI,qBAAA;EACA,sBAAA;APqPR;AOlPI;EACI,qBAAA;EACA,sBAAA;EACA,gCC/BkB;EDgClB,eAAA;EACA,cNRoB;AD4P5B;AOhPA;EACI;IACI,kBAAA;EPkPN;AACF;;AAzRA;ECJA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;ANmUA;AK5TA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;AL8TJ;AK5TI;EAEI,sBAAA;AL6TR;AK1TI;EACI,wBAAA;AL4TR;AKxTA;;EAEI,SAAA;EACA,iBAAA;AL0TJ;AKvTA;EACI,WAAA;ALyTJ;AKtTA;EACI,WAAA;ALwTJ;AKrTA;;;;;EAKI,SAAA;ALuTJ;AKpTA;;;;;;;;;;;;EAYI,oBAAA;ALsTJ;AKnTA;EACI,OAAA;ALqTJ;AKnTI;EACI,WAAA;ALqTR;AKlTI;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ALmTR;AK/SA;EACI,WAAA;ALiTJ;AK9SA;EACI,YAAA;ALgTJ;AMhYA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;ANkYJ;AM/XA;;;;;;;;;;;;EAYI,cAAA;ANiYJ;AM9XA;;EAEI,gBAAA;ANgYJ;AM7XA;;EAEI,YAAA;AN+XJ;AM7XI;;;;EAEI,aAAA;ANiYR;AM7XA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AN+XJ;AM5XA;EACI,yBAAA;EACA,iBAAA;AN8XJ;AM3XA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AN6XJ;AM1XA;;EAEI,sBAAA;AN4XJ;AMzXA;EACI,kBAAA;AN2XJ;AMvXI;EACI,aAAA;ANyXR;AMrXA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANuXJ;AMlXQ;EACI,gBAAA;EACA,cAAA;ANoXZ;AMhXY;EACI,cAAA;ANkXhB;ASrhBA;EACI,kBAAA;EACA,4CAAA;EACA,oBAAA;ATuhBJ;ASrhBI;EACI,qBAAA;EACA,sBAAA;ATuhBR;ASphBI;EACI,qBAAA;EACA,sBAAA;EACA,gCDdkB;ECelB,eAAA;EACA,cRZiB;ADkiBzB;ASlhBA;EACI,kBAAA;ATohBJ;ASlhBI;EACI,qBAAA;EACA,sBAAA;ATohBR;ASjhBI;EACI,qBAAA;EACA,sBAAA;EACA,gCD/BkB;ECgClB,eAAA;EACA,cR7BiB;ADgjBzB;AS/gBA;EACI;IACI,6CAAA;IACA,oBAAA;ETihBN;AACF;AS9gBA;EACI;IACI,kBAAA;IACA,oBAAA;ETghBN;AACF","sourcesContent":[":host-context(.aulani) {\r\n    @import './loader.component.aulani';\r\n}\r\n\r\n:host-context(.wdw) {\r\n    @import './loader.component.wdw';\r\n}\r\n","/* WDW COLOR CODE */\r\n\r\n$page-background: #E8EDF0;\r\n$primary-color: #FFF;\r\n$primary-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);\r\n$secondary-color: #0470AB;\r\n$wdw-primary-message-text-color: #78899E;\r\n$wdw-primary-text-color: #253B56;\r\n$wdw-h3-heading: #424B5A;\r\n$primary-border: thin solid #D8D8D8;\r\n$primary-wdw-link: #1994D7;\r\n$secondary-wdw-link: #1B96D5;\r\n$wdw-message-span: #130026;\r\n$wdw-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$wdw-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$wdw-breadcrumbs-next-color: #73A4BF;\r\n$wdw-disabled-color: #BADFF3;\r\n\r\n/* AULANI COLOR CODE */\r\n$papaya-whitebg-color: #D04901;\r\n$papaya-greybg-color: #B73C00;\r\n$aulani-link-color: #B73C00;\r\n$primary-aulani-border: thin solid #918F8C;\r\n$aulani-border-color: #918F8C;\r\n$aulani-secondary-text-color: #867F77;\r\n$border-background: #FFF;\r\n$primary-aulani-link: #D04901;\r\n$secondary-aulani-link: #D24B00;\r\n$aulani-primary-text-color: #382613;\r\n$aulani-warm-grey-color: #69645E;\r\n$primary-info-text: #8294AA;\r\n$secondary-button-background: #F3EEE6;\r\n$radio-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 15%, #DBDBDB 89%, #FBFBFB 100%);\r\n$footer-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 14%, #DBDBDB 95%, #FBFBFB 100%);\r\n$aulani-hover-link: #B14308;\r\n$aulani-border: radial-gradient($aulani-border-color 0%, #FFF 100%);\r\n$aulani-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$aulani-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$aulani-error-text: #5C4830;\r\n$error-label-color: #FF4605;\r\n$aulani-text-disabed-color: #EFB698;\r\n\r\n$default-button-border: #0079BC;\r\n$default-text-color: #00233C;\r\n$hover-button-border: #006096;\r\n$active-button-border: #083C5D;\r\n$disabled-button-border: #B7E4F7;\r\n","/**\r\n * variables.scss\r\n * Contains the sitewide variables\r\n */\r\n\r\n/**\r\n * Breakpoints variables\r\n */\r\n\r\n$breakpoints: (\r\n    x-small: 0,\r\n    mobile: 320px,\r\n    tablet: 768px,\r\n    desktop: 1024px\r\n);\r\n\r\n$orientations: (\r\n    portrait: portrait,\r\n    landscape: landscape\r\n);\r\n\r\n/**\r\n * Colors variables\r\n */\r\n\r\n$colors: (\r\n    'transparent': transparent,\r\n);\r\n\r\n/**\r\n * z-index variables\r\n */\r\n\r\n$zindex: (\r\n    'base': 1,\r\n    'menu': 2,\r\n    'overlay': 3,\r\n    'modal': 4,\r\n    'toast': 5\r\n);\r\n","/**\r\n * function.scss\r\n * Contains the sitewide functions\r\n */\r\n\r\n@function colors($color) {\r\n    @if not map-has-key($colors, $color) {\r\n        @warn 'No color found for `#{$color}`.';\r\n    }\r\n    \r\n    @return map-get($colors, $color);\r\n}\r\n\r\n@function zindex($layer) {\r\n    @if not map-has-key($zindex, $layer) {\r\n        @warn 'No z-index found for `#{$layer}`.';\r\n    }\r\n    \r\n    @return map-get($zindex, $layer);\r\n}\r\n","/**\r\n * mixins.scss\r\n * Contains the sitewide mixins\r\n */\r\n\r\n@mixin from-breakpoint($bp) {\r\n    @if ($bp == 'x-small') {\r\n        @content;\r\n    }\r\n    @else {\r\n        @if map-has-key($breakpoints, $bp) {\r\n            $list: map-get($breakpoints, $bp);\r\n            $bp: nth($list, 1);\r\n        }\r\n        \r\n        @media screen and (min-width: #{$bp}) {\r\n            @content;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin font($font-size, $line-height, $font-weight:400, $letter-spacing: 0) {\r\n    font-size: $font-size;\r\n    line-height: $line-height;\r\n    font-weight: $font-weight;\r\n    letter-spacing: $letter-spacing;\r\n}\r\n\r\n@mixin host-block() {\r\n    :host {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@mixin float-left() {\r\n    float: left;\r\n}\r\n\r\n@mixin float-right() {\r\n    float: right;\r\n}\r\n\r\n@mixin btn-link($btnColor: #B73C00, $hoverColor: #7C3813) {\r\n    color: $btnColor;\r\n    font-weight: 600;\r\n\r\n    &:hover {\r\n        color: $hoverColor;\r\n    }\r\n\r\n    &:focus {\r\n        color: $btnColor;\r\n        outline: 2px solid $btnColor;\r\n        outline-offset: 4px;\r\n    }\r\n}\r\n","@import '../abstracts/mixins';\r\n\r\n/**\r\n * global.scss\r\n * Contains the sitewide global styles\r\n */\r\n\r\n* {\r\n    background-repeat: no-repeat;\r\n    box-sizing: border-box;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n    position: relative;\r\n    text-rendering: optimizeLegibility;\r\n\r\n    &:before,\r\n    &:after {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    &:focus {\r\n        outline: 1px dotted #000;\r\n    }\r\n}\r\n\r\nhtml,\r\nbody {\r\n    margin: 0;\r\n    min-height: 100vh;\r\n}\r\n\r\nbody {\r\n    width: 100%;\r\n}\r\n\r\nimg {\r\n    width: 100%;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5 {\r\n    margin: 0;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\nspan,\r\na,\r\nli,\r\np,\r\ninput,\r\ntextarea {\r\n    font-family: inherit;\r\n}\r\n\r\n.clearfix {\r\n    zoom: 1;\r\n\r\n    &:after {\r\n        clear: both;\r\n    }\r\n    \r\n    &:after,\r\n    &:before {\r\n        content: '\\0020';\r\n        display: block;\r\n        overflow: hidden;\r\n        visibility: hidden;\r\n        width: 0;\r\n        height: 0;\r\n    }\r\n}\r\n\r\n.float-left {\r\n    float: left;\r\n}\r\n\r\n.float-right {\r\n    float: right;\r\n}\r\n","/**\r\n * reset.scss\r\n * Contains the sitewide css reset\r\n */\r\n\r\nhtml,\r\nbody,\r\ndiv,\r\nspan,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\npre,\r\nabbr,\r\naddress,\r\naddress,\r\ncite,\r\ncode,\r\ndel,\r\ndfn,\r\nem,\r\nimg,\r\nins,\r\nkbd,\r\nq,\r\nsamp,\r\nsmall,\r\nstrong,\r\nsub,\r\nsup,\r\nvar,\r\nb,\r\ni,\r\ndl,\r\ndt,\r\ndd,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\nlegend,\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd,\r\narticle,\r\naside,\r\ncanvas,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\nsection,\r\nsummary,\r\ntime,\r\nmark,\r\naudio,\r\nvideo {\r\n    background: colors('transparent');\r\n    border: 0;\r\n    font-size: 100%;\r\n    margin: 0;\r\n    outline: 0;\r\n    padding: 0;\r\n    vertical-align: baseline;\r\n}\r\n\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nimg,\r\nmenu,\r\nnav,\r\nsection {\r\n    display: block;\r\n}\r\n\r\nol,\r\nul {\r\n    list-style: none;\r\n}\r\n\r\nblockquote,\r\nq {\r\n    quotes: none;\r\n\r\n    :before,\r\n    :after {\r\n        content: none;\r\n    }\r\n}\r\n\r\na {\r\n    background: colors('transparent');\r\n    font-size: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    text-decoration: none;\r\n    touch-action: manipulation;\r\n    vertical-align: baseline;\r\n}\r\n\r\ntable {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n}\r\n\r\nhr {\r\n    border: 0;\r\n    display: block;\r\n    height: 1px;\r\n    margin: 1em 0;\r\n    padding: 0;\r\n}\r\n\r\ninput,\r\nselect {\r\n    vertical-align: middle;\r\n}\r\n\r\naddress {\r\n    font-style: normal;\r\n}\r\n\r\ninput {\r\n    &::-ms-clear {\r\n        display: none;\r\n    }\r\n}\r\n\r\nbutton {\r\n    background: none;\r\n    border: 0;\r\n    padding: 0;\r\n}\r\n\r\n.aulani {\r\n    .room-ready-terms-and-conditions {\r\n        p a {\r\n            font-weight: 600;\r\n            color: #D04901;\r\n        }\r\n\r\n        &.edit {\r\n            p a {\r\n                color: #B73C00;\r\n            }\r\n        }\r\n    }\r\n}\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.loader.medium-loader {\r\n    text-align: center;\r\n    padding-top: calc(50vh - 92px - 30px);\r\n    padding-bottom: 30px;\r\n\r\n    wdpr-rt-aulani-loading {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    span {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        font-family: $inspiretwdc-medium-font;\r\n        font-size: 14px;\r\n        color: $aulani-primary-text-color;\r\n    }\r\n}\r\n\r\n.loader.small-loader {\r\n    text-align: center;\r\n\r\n    wdpr-rt-aulani-loading {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    span {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        font-family: $inspiretwdc-medium-font;\r\n        font-size: 14px;\r\n        color: $aulani-primary-text-color;\r\n    }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n    .loader.medium-loader {\r\n        padding-top: 100px;\r\n    }\r\n}\r\n","$inspiretwdc-font: 'InspireTWDC';\r\n$inspiretwdc-book-font: 'InspireTWDCBook';\r\n$inspiretwdc-light-font: 'InspireTWDCLight';\r\n$inspiretwdc-medium-font: 'InspireTWDCMedium';\r\n$inspiretwdc-heavy-font: 'InspireTWDCHeavy';\r\n$inspiretwdc-black-font: 'InspireTWDCBlack';\r\n$inspiretwdc-roman-font: 'InspireTWDCRoman';\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.loader.medium-loader {\r\n    text-align: center;\r\n    padding-top: calc(50vh - 48px - 27px - 30px);\r\n    padding-bottom: 30px;\r\n\r\n    wdpr-loading {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    span {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        font-family: $inspiretwdc-medium-font;\r\n        font-size: 14px;\r\n        color: $wdw-primary-text-color;\r\n    }\r\n}\r\n\r\n.loader.small-loader {\r\n    text-align: center;\r\n\r\n    wdpr-loading {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    span {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        font-family: $inspiretwdc-medium-font;\r\n        font-size: 14px;\r\n        color: $wdw-primary-text-color;\r\n    }\r\n}\r\n\r\n@media (min-width: 767px) {\r\n    .loader.medium-loader {\r\n        padding-top: calc(50vh - 102px - 40px - 30px);\r\n        padding-bottom: 30px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n    .loader.medium-loader {\r\n        padding-top: 100px;\r\n        padding-bottom: 30px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
